<template>
  <section
    class="c-section--thanks text-center py-5 d-flex flex-column justify-content-center"
  >
    <div class="container">
      <b-skeleton-wrapper :loading="isLoadingEvent">
        <template #loading>
          <div class="row justify-content-center align-items-center">
            <div class="col col-7">
              <h2 class="fs-25 w-bold mb-3">Creando evento...</h2>
              <b-skeleton width="100%"></b-skeleton>
            </div>
          </div>
        </template>

        <section class="d-flex flex-column justify-content-center align-items-center">
          <template v-if="error.active">
            <h2 class="c-modal__title">{{ error.title }}</h2>
            <p class="mb-4">{{ error.message }}</p>
            <router-link to="/" class="c-button c-button--primary d-block w-auto">
              Volver
            </router-link>
          </template>
          <template v-else>
            <h2 class="c-modal__title">¡Evento en google calendar creado exitosamente!</h2>
            <p class="mb-4">Revisa tu calendario de google, ¡te esperamos en el evento!</p>
            <router-link to="/" class="c-button c-button--primary d-block w-auto">
              Volver
            </router-link>
          </template>
        </section>
      </b-skeleton-wrapper>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      error: {
        active: false,
        title: '',
        message: '',
      },

      isLoadingEvent: true,
    };
  },
  mounted() {
    if (this.$route.query.code) {
      this.addGoogleEvent();
    }
  },
  methods: {
    addGoogleEvent() {
      this.isLoadingEvent = true;

      const formData = new FormData();
      const ipesaCalendar = JSON.parse(window.sessionStorage.getItem('ipesa_calendar'));

      formData.append('email', ipesaCalendar.email);
      formData.append('code', this.$route.query.code);

      fetch(`${process.env.VUE_APP_API}/assistants/event`, {
        method: 'POST',
        body: formData,
      })
        .then((res) => {
          if (res.status === 201 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            this.isLoadingEvent = false;
          } else {
            this.error = {
              active: true,
              title: 'Error al crear evento',
              message: '¡Ha ocurrido un error crear el evento en google! 😥⚠️🚨, intentelo nuevamente',
            };

            this.isLoadingEvent = false;
          }
        })
        .catch((err) => {
          this.error = {
            active: true,
            title: 'Error al crear evento',
            message: '¡Ha ocurrido un error crear el evento en google! 😥⚠️🚨, intentelo nuevamente',
          };

          this.isLoadingEvent = false;

          throw err;
        });
    },
  },
};
</script>
